import React from "react";
import BranchRankingComponent from "../../components/branchRankingComponents/BranchRankingComponent";

const BranchRankingContainer: React.FC<{ isTabSelected: boolean }> = ({isTabSelected}) => {
    return (<BranchRankingComponent isTabSelected={isTabSelected}/>);
};

export default BranchRankingContainer;
